import { z } from 'zod';

/**
 * UUIDv7 — 36-char hyphenated. Accepts any UUID; we don't enforce
 * version-7 at the type level because v7 is structurally a UUID and
 * generation is centralised.
 */
export const uuidSchema = z.string().uuid();

/**
 * Loose ID reference — accepts both UUIDv7 and seed-shaped kebab
 * strings (`org-acme`, `user-priya`, `con-acme`). DB columns are
 * plain TEXT so both shapes coexist in dev/staging.
 *
 * Accepts: 1–64 char alphanumeric + hyphens/underscores.
 * Rejects: empty, whitespace, >64 chars.
 */
export const idRefSchema = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[A-Za-z0-9_-]+$/, 'Invalid id format');

export const isoTimestampSchema = z
  .string()
  .datetime({ offset: true });

export const isoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');

export const tzSchema = z.string().min(1);

export const hoursSchema = z
  .number()
  .nonnegative()
  .finite();

export const centsSchema = z
  .number()
  .int()
  .nonnegative();

/** Email — lowercase, RFC-light. */
export const emailSchema = z.string().email().toLowerCase();

/** Ticket number — `T-####` four-or-more digits, monotonic across the workspace. */
export const ticketNumberSchema = z
  .string()
  .regex(/^T-\d{4,}$/, 'Expected T-#### format');
